import { render, staticRenderFns } from "./realtimeTrade.vue?vue&type=template&id=03c7c024&scoped=true&"
import script from "./realtimeTrade.vue?vue&type=script&lang=js&"
export * from "./realtimeTrade.vue?vue&type=script&lang=js&"
import style0 from "./realtimeTrade.vue?vue&type=style&index=0&id=03c7c024&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c7c024",
  null
  
)

export default component.exports